import { useState } from 'react';
import { inputFieldClasses } from './formInputClasses';

const labelClasses = 'block mb-2 text-content font-sans';

const prefixClasses = `absolute left-3 top-1/2 -translate-y-1/2
  pointer-events-none text-sm`;

const inputBaseClasses = `w-full h-10 pl-6 pr-3 py-1.5
  font-sans text-base text-content
  bg-white border border-border rounded-md transition-colors
  focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary-ring
  disabled:opacity-60 disabled:cursor-not-allowed`;

const CurrencyInput = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  disabled = false,
  className,
  ...props
}) => {

  const [isFocused, setIsFocused] = useState(false);
  const disabledClass = disabled ? 'cursor-not-allowed' : '';

  const getDisplayValue = () => {

    if (isFocused || !value) {
      return value || '';
    }

    const numValue = parseFloat(value);
    if (isNaN(numValue)) {
      return value;
    }

   return numValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <>
      {label && <label className={labelClasses}>{label}</label>}
      <div className={`${inputFieldClasses} relative`}>
        <span
          className={`${prefixClasses} ${disabled ? 'text-disabled' : 'text-content'}`}
        >
          $
        </span>
        <input
          {...props}
          type={isFocused ? 'number' : 'text'}
          name={name}
          value={getDisplayValue()}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={`${className || inputBaseClasses} ${disabledClass}`}

        />
      </div>
    </>
  );
};

export default CurrencyInput;
